// extracted by mini-css-extract-plugin
var _1 = "BuildingGroupTableRow-moduleBuildingGroupTableRow__D6RLr TableComponent-modulerow__xPAo4";
export { _1 as "BuildingGroupTableRow" }
